import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatImageUrl(url) {
  if (!url) return "";
  if (typeof url !== "string") return url;
  
  // If it's a blob/object URL, return as is
  if (url.startsWith("blob:") || url.startsWith("data:")) return url;
  
  // If it's an absolute filesystem path from backend, convert to web path
  if (url.startsWith("/var/www/uploads/")) {
    return url.replace("/var/www/uploads/", "/uploads/");
  }
  
  return url;
}
